import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { environment } from 'src/environments/environment';
import { IWorkScheduleTemplate } from '../models/work-schedule-template.model';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class WorkScheduleTemplateApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/ScheduleTemplates`;
  }

  constructor(private http: HttpClient) {}

  loadWorkScheduleTemplates(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IWorkScheduleTemplate[]>> {
    let url = `${this.url}`;
    if (currentFilter) {
      url = `${url}?Page=${currentFilter.pageIndex}&PageSize=${currentFilter.pageSize}`;
    }
    if (currentFilter?.searchTerm) {
      url = `${url}&GlobalSearch=${currentFilter.searchTerm}`;
    }
    if (currentFilter?.orderBy && currentFilter.ascDesc) {
      url = `${url}&OrderBy[${currentFilter.orderBy}]=${currentFilter.ascDesc}`;
    }
    return this.http.get<ApiResponse<IWorkScheduleTemplate[]>>(url);
  }

  loadAllWorkScheduleTemplates(): Observable<IWorkScheduleTemplate[]> {
    const url = `${this.url}/All`;
    return this.http.get<IWorkScheduleTemplate[]>(url);
  }

  loadWorkScheduleTemplateById(id: string): Observable<IWorkScheduleTemplate> {
    const url = `${this.url}/${id}`;
    return this.http.get<IWorkScheduleTemplate>(url);
  }

  createWorkScheduleTemplate(
    workScheduleTemplate: IWorkScheduleTemplate
  ): Observable<IWorkScheduleTemplate> {
    return this.http.post<IWorkScheduleTemplate>(this.url, workScheduleTemplate, { headers });
  }

  updateWorkScheduleTemplate(
    workScheduleTemplate: IWorkScheduleTemplate
  ): Observable<IWorkScheduleTemplate> {
    const url = `${this.url}/${workScheduleTemplate.id}`;
    return this.http.put<IWorkScheduleTemplate>(url, workScheduleTemplate, { headers });
  }

  deleteWorkScheduleTemplate(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }
}
